import { render, staticRenderFns } from "./SurveyQualificationQuestion.vue?vue&type=template&id=00896a33&scoped=true&"
import script from "./SurveyQualificationQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyQualificationQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00896a33",
  null
  
)

export default component.exports